import React from 'react';

export const Download: React.FC<React.HTMLAttributes<SVGElement>> = (props) => (
  <svg viewBox="8 8 16 16" {...props}>
    <path
      d="M16 19.173a.493.493 0 01-.493-.493V8.493a.493.493 0 01.986 0v10.188a.493.493 0 01-.493.492zm0 0"
      fill="currentColor"
    />
    <path
      d="M16 19.314a.489.489 0 01-.348-.145l-2.629-2.629a.495.495 0 01.7-.7l2.281 2.281 2.281-2.281a.495.495 0 01.7.7l-2.629 2.629a.494.494 0 01-.356.145zm0 0"
      fill="currentColor"
    />
    <path
      d="M22.167 24H9.833A1.822 1.822 0 018 22.193v-2.958a.5.5 0 01.5-.493.5.5 0 01.5.493v2.958a.829.829 0 00.833.822h12.334a.829.829 0 00.833-.822v-2.958a.5.5 0 011 0v2.958A1.822 1.822 0 0122.167 24zm0 0"
      fill="currentColor"
    />
  </svg>
);
